/* dz-telaio-fit.js — su telefono trova dove sta la bici nella foto (il bianco attorno
   cambia da foto a foto) e la ingrandisce e centra nel riquadro. Il riquadro su telefono
   va da bordo a bordo dello schermo ed e' piu' alto. Se non riesce, resta la foto normale.
   Inoltre: niente riga arancione "Pinarello · Kit telaio · ..." sopra il titolo, e su
   telefono la nota della Dogma F (foto della bici completa) va sotto la foto, non sopra. */
(function () {
  var mq = window.matchMedia('(max-width:960px)');
  var cache = {};
  var F = '.dztp.dztp-chiaro[aria-label*="Dogma F Kit telaio"]';

  var css = document.createElement('style');
  css.textContent =
    '.dztp.dztp-chiaro .dztp-hero .dztp-k{display:none}' +
    '@media (max-width:960px){' +
      '.dztp-chiaro.dztp--f .dztp-stage-in{margin-left:-12px;margin-right:-12px;border-radius:0;height:clamp(360px,104vw,640px)}' +
      '.dztp-chiaro.dztp--f .dztp-stage-tag{left:20px;right:20px}' +
      F + ' .dztp-stage-in::after{content:none!important;display:none!important}' +
      F + ' .dztp-stage::after{content:"Foto della bici completa: il kit telaio non comprende gruppo, ruote e componenti.";display:block;margin:0 8px 10px;font-size:13px;line-height:1.4;color:#6e6e73;text-align:center}' +
    '}';
  document.head.appendChild(css);

  function piccola(url) {
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=400');
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=400';
  }

  function bordi(url, cb) {
    if (cache[url] !== undefined) return cb(cache[url]);
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var r = im.naturalHeight / im.naturalWidth, w = 200, h = Math.round(200 * r);
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.fillStyle = '#fff'; x.fillRect(0, 0, w, h);
        x.drawImage(im, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data;
        var x0 = w, x1 = -1, y0 = h, y1 = -1;
        for (var y = 0; y < h; y++) {
          for (var i = 0; i < w; i++) {
            var k = (y * w + i) * 4;
            if (Math.min(d[k], d[k + 1], d[k + 2]) < 232) {
              if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
        }
        cache[url] = x1 < 0 ? null : { x0: x0 / w, x1: (x1 + 1) / w, y0: y0 / h, y1: (y1 + 1) / h, r: r };
      } catch (e) { cache[url] = null; }
      cb(cache[url]);
    };
    im.onerror = function () { cache[url] = null; cb(null); };
    im.src = piccola(url);
  }

  function libera(img) {
    ['inset', 'left', 'top', 'width', 'height', 'max-width', 'object-fit'].forEach(function (p) { img.style.removeProperty(p); });
  }

  /* spazio occupato in alto da scritte dentro il riquadro */
  function altoOccupato(st, img) {
    var top = st.getBoundingClientRect().top, max = 0;
    Array.prototype.forEach.call(st.children, function (el) {
      if (el === img || el.classList.contains('dztp-stage-tag') || el.offsetParent === null) return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top - top < st.clientHeight / 3) max = Math.max(max, r.bottom - top);
    });
    return max;
  }

  function adatta(img) {
    var st = img.closest('.dztp-stage-in');
    if (!st) return;
    if (!mq.matches) { libera(img); return; }
    var url = img.getAttribute('src');
    if (!url) return;
    bordi(url, function (b) {
      if (!b || img.getAttribute('src') !== url) return;
      var W = st.clientWidth, H = st.clientHeight;
      var tag = st.querySelector('.dztp-stage-tag');
      var basso = tag ? tag.offsetHeight + 26 : 60;
      var aT = Math.max(H * 0.05, altoOccupato(st, img) + 8);
      var aH = H - basso - aT, aW = W * 0.96;
      var bw = b.x1 - b.x0, bh = b.y1 - b.y0;
      var IW = Math.min(aW / bw, aH / (b.r * bh));
      var IH = IW * b.r;
      var s = img.style;
      s.setProperty('inset', 'auto');
      s.setProperty('left', (W / 2 - IW * (b.x0 + bw / 2)) + 'px');
      s.setProperty('top', (aT + aH / 2 - IH * (b.y0 + bh / 2)) + 'px');
      s.setProperty('width', IW + 'px');
      s.setProperty('height', IH + 'px');
      s.setProperty('max-width', 'none');
      s.setProperty('object-fit', 'fill');
    });
  }

  function avvia() {
    var imgs = document.querySelectorAll('[data-dztp-foto]');
    Array.prototype.forEach.call(imgs, function (img) {
      adatta(img);
      new MutationObserver(function () { adatta(img); }).observe(img, { attributes: true, attributeFilter: ['src'] });
    });
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { Array.prototype.forEach.call(imgs, adatta); }, 150);
    });
    window.addEventListener('load', function () { Array.prototype.forEach.call(imgs, adatta); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
